/**************************************************************************
 * ITEMS MODEL (product, coupons, etc)
 **************************************************************************/
function Product(sku, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage, productAlcohol, listName, aisleId) {
    this.sku = sku;
    this.qty = qty;
    this.optionId = optionId;
    this.optionCode = optionCode;
    this.productName = productName;
    this.shopTrackingWebPage = shopTrackingWebPage;
    this.shopTrackingToken = shopTrackingToken;
    this.productAlcohol = productAlcohol;
    this.listName = listName;
    this.aisleId = aisleId;
}

Product.prototype.getData = function () {
    var data = {
        productCode: this.sku,
        quantity: this.qty,
        optionId: this.optionId,
        optionCode: this.optionCode,
        productName: this.productName,
        shopTrackingWebPage: this.shopTrackingWebPage,
        shopTrackingToken: this.shopTrackingToken,
        productAlcohol: this.productAlcohol,
        listName: this.listName,
        aisleId: this.aisleId
    };

    return data;
};

Product.prototype.stringify = function () {
    return JSON.stringify(this.getData());
};

Product.prototype.getCode = function () {
    return this.sku;
};

Product.prototype.get = function () {
    return this.sku;
};

Product.prototype.getType = function () {
    return 'Product';
};

function parseProduct(dataAsJson) {
    var data = JSON.parse(dataAsJson);
    return new Product(
        data.productCode,
        data.quantity,
        data.optionId,
        data.optionCode,
        data.productName,
        data.shopTrackingWebPage,
        data.shopTrackingToken,
        data.listName,
        data.aisleId
    );
}

function stringifyProduct(products) {
    var productsList = [];
    if (Array.isArray(products)) {
        products.forEach(function (product) {
            productsList.push(product.getData());
        });
    } else {
        productsList.push(products.getData());
    }
    return JSON.stringify(productsList);
}

function Coupon(id, buttonId, shopTrackingWebPage, shopTrackingToken) {
    this.id = id;
    this.buttonId = buttonId;
    this.shopTrackingToken = shopTrackingToken;
    this.shopTrackingWebPage = shopTrackingWebPage;
}

Coupon.prototype.getId = function () {
    return this.id;
};

Coupon.prototype.getButtonId = function () {
    return this.buttonId;
};

Coupon.prototype.getType = function () {
    return 'Coupon';
};

Coupon.prototype.getShopTrackingToken = function () {
    return this.shopTrackingToken;
};

Coupon.prototype.getShopTrackingWebPage = function () {
    return this.shopTrackingWebPage;
};

Coupon.prototype.getData = function () {
    var data = {
        couponId: this.id,
        buttonId: this.buttonId,
        type: this.getType(),
        shopTrackingWebPage: this.shopTrackingWebPage,
        shopTrackingToken: this.shopTrackingToken
    };

    return JSON.stringify(data);
};

function selectProductOptionPriceUpdate() {
    var $selectedOption = $('option:selected', this);
    var mainPrice = $selectedOption.attr('main-price');
    var unitFactor = $selectedOption.attr('unit-factor');
    var memberPrice = $selectedOption.attr('member-price');
    var regularPrice = $selectedOption.attr('regular-price');
    unitFactor = Math.round(parseInt(unitFactor));

    $(this).find('option').removeClass('activeOption');
    $selectedOption.addClass('activeOption');
    var $product;

    // Product Listing
    if ($(this).closest('.tile-product').length) {
        $product = $(this).closest('.tile-product');

        // Product Details
    } else if ($(this).closest('.productPDP').length) {
        $product = $(this).closest('.productPDP');

        // Product Cart
    } else if ($(this).closest('.product-card').length) {
        $product = $(this).closest('.product-card');

        //Autocomplete product
    } else if ($(this).closest('.product-tile-horizontal').length) {
        $product = $(this).closest('.product-tile-horizontal');
    }

    if ($product instanceof jQuery) {
        $product.find('.price-update').text(mainPrice);
        $product.find('.unit-factor').text(unitFactor);
        $product.find('.member-price').text(memberPrice);
        if (regularPrice && regularPrice.trim().length > 0) {
            $product.find('.pi-regular-price .pi-price').text(regularPrice);
        }
    }
}

function updateProductTilesAfterUpdate(item) {
    let $addedProductTiles = $('[data-product-code="' + item.sku + '"]');
    if ($addedProductTiles.length) {
        $addedProductTiles.find('.pt--image--incart.hide, .pt--image--incart-wrapper.hide').removeClass('hide');
        $addedProductTiles.find('.pt--actions, .pi--actions').removeClass('actions--not-in-cart');
        $addedProductTiles.find('.pt__content--actions').addClass('in-cart');
        $addedProductTiles.find('.minus-updateCart').attr('tabindex', 0);
        $addedProductTiles.find('.plus-updateCart').attr('tabindex', 0);

        if ($addedProductTiles.hasClass('productPDP')) {
            $('.pdpVisuals .pt--image--incart-wrapper.hide').removeClass('hide');
        }
    }

    // Refresh product tiles except for cart starter tiles (since cart updates do not affect the cart starter products).
    // This prevents mini-cart from affecting cart starter tiles and other mini-cart tiles with the same sku
    let $addedProductTilesToUpdate = $addedProductTiles.not('.product-tile-cart-starter').not('.mini--cart--product');
    if ($addedProductTilesToUpdate.length) {
        var minQty = +($addedProductTiles.data('min-qty'));
        var $minusBtn = $addedProductTiles.find('.minus-addToCart');
        $addedProductTilesToUpdate.attr('data-cart-entry', item.entryNumber);
        $addedProductTilesToUpdate.attr('data-substitution-permission', item.substitutionPermission);
        $addedProductTilesToUpdate.find('.qty-addToCart').text(item.quantity);
        if (item.selectedConfigurationId != null) {
            $addedProductTilesToUpdate.find('.select-addToCart').val(item.selectedConfigurationId).change();
        }

        if (minQty == item.quantity) {
            $minusBtn.removeClass('multiple-in-cart');
        } else {
            $minusBtn.addClass('multiple-in-cart');
        }
    }
}

function displayFancyErrorMessage(messages, reloadOnClose) {
    var $changeOrderNewStorePopup = $('#changeOrderNewStorePopup');

    if (!!messages && messages.length > 0) {
        $changeOrderNewStorePopup.find('.textReplacedByAjax').empty();
        $.each(messages, function (key, value) {
            $changeOrderNewStorePopup.find('.textReplacedByAjax').append(`<p><strong>${value}</strong></p>`);
        });

        $('#changeOrderNewStorePopup').dishide({
                eventOnClose: function () {
                    // Reload page on close if needed
                    if (typeof reloadOnClose !== 'undefined' && reloadOnClose) {
                        window.location.reload(true);
                    }
                }
            },
            'open'
        );
    }
}

function executeIfCallBack(addToCartCallbackFunction) {
    if (addToCartCallbackFunction) {
        if (window[addToCartCallbackFunction]) {
            window[addToCartCallbackFunction]();
        } else {
            addToCartCallbackFunction();
        }
        addToCartCallbackFunction = null;
    }
}

/**
 * Display error message when item is added to cart
 * if the message is already displayed, it is updated
 * else when add en other message
 */
function updateErrorMessages(product, messages, statusCode) {
    hideErrorMessages(product);
    if (!!messages && messages.length > 0) {
        product.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
        $.each(messages, function (key, value) {
            var messageText = value;
            var classes = 'addItemError focusOnMySelect ' + statusCode;
            addErrorMessagetoProduct(product, classes, messageText);
        });
    }
}

function hideErrorMessages(product) {
    product.find('.error-summary').addClass('hide');
    product.find('.product-make-choice-error').addClass('hide');
    product.find('.product-make-choice-cart-starter-error').addClass('hide');
    product.find('.product-age-restriction-cart-starter-error').addClass('hide');
    product.find('.product-cart-starter-add-error').addClass('hide');
    product.find('.product-cart-starter-delete-error').addClass('hide');
    product.find('.product-cart-starter-update-error').addClass('hide');
    product.find('.product-cart-update-error').addClass('hide');
    product.find('.product-cart-delete-error').addClass('hide');
    product.find('.addItemError').remove();
}

function addErrorMessagetoProduct(product, classes, message) {
    var error = product.find('.error-summary ul');
    error.append('<li><a href="" class="focusOnMySelect ' + classes + '">' + message + '</a>');
}

function cleanUpUrlFromPreviousErrors(location) {
    location = TINK.removeParamFromUrl('product-code', location);
    location = TINK.removeParamFromUrl('error-action', location);
    return location;
}

function showProductsPreviousErrors() {
    if (typeof errorCartProductCode !== 'undefined' && errorCartProductCode !== '' && typeof errorCartProductAction !== 'undefined' && errorCartProductAction) {
        $('[data-product-code="' + errorCartProductCode + '"]').each(function () {
            if (errorCartProductAction === 'delete') {
                $(this).find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                $(this).find('.product-cart-delete-error').removeClass('hide');
            } else if (errorCartProductAction === 'update') {
                $(this).find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
                $(this).find('.product-cart-update-error').removeClass('hide');
            }
        });
    }
}

function _resetDefaultTileState(product) {
    _resetQuantity(product);
    _resetAddToCartButtons(product);
    _resetEntryNumber(product);

    if (product.hasClass('product-tile-spontaneous-purchase')) {
        updateQuantityButtonsState(product);
    }
}

function resetDefaultOption(product) {
    var selector = product.find('.select-addToCart');
    var defaultOption = product.find('[default-option="true"]');
    selector.val(defaultOption.val()).change();
}

function _resetQuantity(products) {
    products.each(function (index, product) {
        if ($(this).hasClass('product-tile-spontaneous-purchase')) {
            $(this).find('.qty-addToCart').text('0');
        } else {
            $(this).find('.qty-addToCart').text(product.dataset.minQty);
        }
    });
}

function _resetAddToCartButtons(product) {
    product.find('.pt--actions, .pi--actions').addClass('actions--not-in-cart');
    product.find('.pt__content--actions').removeClass('in-cart');
}

function _resetEntryNumber(product) {
    product.attr('data-cart-entry', null);
}

function _updateHeaderCartItemNumber(nbItemsInCart) {
    $(".cart-qty span").text(nbItemsInCart);
}

function _updateSpontaneousContinueButton() {
    var impulsiveProductCount = $('.mini-cart-spontaneous-purchase .product-tile-spontaneous-purchase');
    var addedImpulsiveProductCount = $('.mini-cart-spontaneous-purchase .actions--not-in-cart');
    var btn = $('.checkout-button--spontaneous');
    if (impulsiveProductCount.length !== addedImpulsiveProductCount.length) {
        btn.text(impulsivePurchaseContinueMessage);
        btn.removeClass('cta-secondary').addClass('cta-primary').removeClass('no-thank-you');
    } else {
        btn.text(impulsivePurchaseNoThankYouMessage);
        btn.removeClass('cta-primary').addClass('cta-secondary').addClass('no-thank-you');
    }
}

function _updateExpressDelivery(totalEntries) {
    let $maxItemSection = $('.express-delivery-max-item');
    $('#modal-service-and-timeslot').data('express-item-entry', totalEntries);
    if ($maxItemSection.length) {
        // Update Express Delivery Progress bar
        let warningItemNumber = parseInt($maxItemSection.attr('data-warning-item-number'));
        let maxItemNumber = parseInt($maxItemSection.attr('data-max-item-number'));

        $('#expressCartItems').text(totalEntries);

        let $progressBar = $('#expressMaxItemsProgressBar');
        let $progressBarMessage = $('.ed-max-item__message');
        $progressBar.val(totalEntries);
        if (totalEntries > maxItemNumber) {
            $progressBarMessage.text($maxItemSection.attr('data-max-item-exceeded-text'));
        } else {
            $progressBarMessage.text($maxItemSection.attr('data-max-item-text'));
        }
        if (totalEntries > maxItemNumber) {
            $maxItemSection.addClass('ed-max-item-reached');
            $progressBar.addClass('ed-max-item-reached__progress-bar');
        } else{
            $maxItemSection.removeClass('ed-max-item-reached');
            $progressBar.removeClass('ed-max-item-reached__progress-bar');
        }
        if (totalEntries >= warningItemNumber) {
            $maxItemSection.removeClass('hide');
            $('.header-wrapper .header__main.header--container').addClass('ed-max-item__progress-bar-offset');
            if (sessionStorage.getItem('expressServiceStickyBannerShown') === null) {
                sessionStorage.setItem('expressServiceStickyBannerShown', 'true');
                pushDataLayerServiceAndTimeslotEDBannerShown();
            }
        } else {
            $maxItemSection.addClass('hide');
            $('.header-wrapper .header__main.header--container').removeClass('ed-max-item__progress-bar-offset');
        }
    }

    // Update spontaneous purchase display condition
    let $miniCartSpontaneousSection = $('.mini-cart-side-panel--spontaneous');
    let maxEntriesCriteria = $miniCartSpontaneousSection.attr('data-max-entries-criteria');
    if (typeof maxEntriesCriteria !== 'undefined') {
        $miniCartSpontaneousSection.attr('data-total-entries', totalEntries);
        MiniCart.updateMiniCartSpontaneousReadyCondition(totalEntries, parseInt(maxEntriesCriteria));
    }
}

function setStoreId() {
    window['storeId'] = true;
}

function isReloadAfterClosingModalOrAddingToCart() {
    return typeof shoppingCartUrl !== 'undefined' && window.location.pathname === shoppingCartUrl;
}

$(document).on('click', '.plus-updateCart, .minus-updateCart', debounce(function(event) {
    window['updateCartProduct'](event.target);
}, TINK.isIOS() ? 700: 500, false));

$(document).ready(function () {

    //Adding ellipsis to long product title
    shortenLongTextsInCouponFragment();

    showProductsPreviousErrors();

    window['cartItem'] = null;
    var addToCartErrorCallback;
    var addToCartEndCallback;
    var addToCartDisplaySuccessNotification = false;
    var notificationSuccessCallback;

    /**************************************************************************
     * PRODUCT QUANTITY FUNCTIONS
     **************************************************************************/
    //update description on a select box change

    $(document).on('change', '.select-addToCart', function (e) {
        var product = $(this).closest('.item-addToCart');
        var desc = $(this).find('option:selected').attr('desc');

        // FOR DOUBLE SELECTION OPTION ON PDP PAGE
        const $optionSelect = $('.pdp-select .pt--cut-select');
        const $optionSelectSticky = $('.sticky-select .pt--cut-select');
        let $productSelect = $(this);
        let selectVal = $productSelect.val();

        if ($productSelect.is($optionSelect)) {
            $optionSelectSticky.val(selectVal);
        } else if ($productSelect.is($optionSelectSticky)) {
            $optionSelect.val(selectVal);
        }

        if (desc) {
            product.find('.desc-addToCart').text(desc);
            product.find('.desc-addToCart').addClass('pt-10');
            product.find('.pi-actions-approx').addClass('mb-0');
        } else {
            product.find('.desc-addToCart').empty();
            product.find('.desc-addToCart').removeClass('pt-10');
            product.find('.pi-actions-approx').removeClass('mb-0');
        }

        if (e.originalEvent) {
            if (!product.hasClass('product-tile-cart-starter') && (!product.hasClass('product-card') || product.hasClass('product-tile-spontaneous-purchase'))) {
                _resetDefaultTileState(product);
            }
        }
    });

    /**
     * When option change for a CUVPA product in cart, listing or details,
     * we need to update :
     * - main price and unit factor
     * - Member price
     */

    $(document).on('change', '.select-addToCart', selectProductOptionPriceUpdate);

    function findFlowToAdd(product, errorBox, target, postalCode) {
        let overlayEnabled = productOverlayEnabled !== 'undefined' && productOverlayEnabled;
        let isMyFavouritePage = window.location.pathname === myFavouritesUrl;
        if (!window['storeId'] || (overlayEnabled && showOverlay(isMyFavouritePage))) {
            findFlowToCreateCart(product, errorBox, target, postalCode, isMyFavouritePage);
        } else {
            window['executeAddProductToCart'](product, errorBox);
            let isHomePage = (typeof homePageUrl !== 'undefined' && window.location.pathname == homePageUrl) || (typeof alternateHomePageFrUrl !== 'undefined' && window.location.pathname == alternateHomePageFrUrl);
            let isPLP = document.querySelectorAll('.products-search--grid').length;

            // check if in homepage and product tile come from body
            let isPlpBool = false;
            if (isPLP) {
                isPlpBool = true;
            }
            if (isHomePage && $(product).closest('#content-temp').length || isPLP && $(product).closest('#content-temp').length) {
                BoughtWith.handleBoughtWithCarousel(product, isPlpBool);
            }
        }
    }

    function findFlowToCreateCart(product, errorBox, target, postalCode, isMyFavouritePage) {
        if (!isInWebview() && productOverlayEnabled !== 'undefined' && productOverlayEnabled && !isMyFavouritePage) {
            let $targetTileTrigger = $(target);
            showOverlayServiceBox.findServiceByPostalCode(undefined, $targetTileTrigger, errorBox, false);
        } else {
            ServiceTimeslot.openServiceAndTimeslot.bind(target)(postalCode, product, errorBox);
        }
    }

    function showOverlay(isMyFavouritePage) {
        let hideOverlayCookie = TINK.getCookie('hide_product_overlay');
        let impulsivePurchasesPanelOpened = !$('.mini-cart-spontaneous-purchase').hasClass('hide') && $('.mini-cart-spontaneous-purchase').closest('.mini-cart-side-panel').hasClass('dishide-target--active');
        let serviceTypeExpressDelivery = serviceType && serviceType == 'cornershop_home_delivery';
        let showOverlay = (typeof hideOverlayCookie == 'undefined' || !hideOverlayCookie)
            && typeof cartWithoutTimeslot != 'undefined' && cartWithoutTimeslot
            && !serviceTypeExpressDelivery
            && !isMyFavouritePage
            && !isInWebview()
            && !impulsivePurchasesPanelOpened;

        return showOverlay;
    }

    window['addSelectedProductsToCart'] = function (products, productsTiles, callBackEnd, callBackError, trigger, postalCode, errorBox, displayNotification, callbackNotifSuccess) {
        if (!products) {
            return;
        }
        window['cartItem'] = products;

        addToCartErrorCallback = callBackError;
        addToCartEndCallback = callBackEnd;
        addToCartDisplaySuccessNotification = displayNotification;
        notificationSuccessCallback = callbackNotifSuccess;

        findFlowToAdd(productsTiles, errorBox, trigger, postalCode);
    };

    window['addProductToCart'] = function (target, errorBoxId) {
        // Not normal if the user try to add a product while the store locator is open
        if (ServiceTimeslot.isModalServiceAndTimeslotOpen()) {
            return;
        }

        if (isInWebview() && !isAuthenticated) {
            // send event to redirect to connection page in the App
            sendUserNotAuthenticatedEventToDevice();
            return;
        }

        var product = $(target).closest('.item-addToCart'),
            qty = +(product.find('.qty-addToCart').first().text()),
            selector = product.find('.select-addToCart'),
            sku = product.data('product-code'),
            optionId = $('option:selected', selector).attr('code-id'),
            optionCode = selector.attr('data-configuration-code'),
            errorBox = $('#' + errorBoxId);

        //remove older errors
        errorBox.hide();

        addToCartErrorCallback = $(target).data('onaddtocarterror');
        addToCartEndCallback = $(target).data('onaddtocartend');

        $('.item-addToCart').each(function () {
            var curSelect = $(this).find('.select-addToCart');
            if (curSelect && curSelect.hasClass('error')) {
                curSelect.removeClass('error');
                $(this).find('.error-summary').addClass('hide');
                $(this).find('.product-make-choice-error').addClass('hide');
            }
        });

        //select first option for Express Delivery if no value selected
        if (selector && selector.find('option:selected').val() == '1' && $('.mini-cart-side-panel--spontaneous').attr('data-express-service') === 'true') {
            if (selector.find('option').length > 1) {
                selector.find('option:eq(1)').prop('selected', true);
                optionId = $('option:selected', selector).attr('code-id');
            }
        }

        //add error if no value selected
        if (selector && selector.find('option:selected').val() === '1') {
            selector.addClass('error');
            hideErrorMessages(product);
            product.find('.error-summary').removeClass('hide').attr('tabindex', '0').focus();
            product.find('.product-make-choice-error').removeClass('hide');

            if (product.hasClass('product-tile-spontaneous-purchase')) {
                _resetQuantity(product);

                var max = +(product.data('max-qty'));
                var qty = +(product.find('.qty-addToCart').first().text());
                product.find('.plus-addToCart').prop('disabled', qty > max);
                product.find('.minus-addToCart').prop('disabled', true);
            }
            return;
        }

        var productName = product.data('product-name');
        var shopTrackingToken = product.data('shop-tracking-token');
        var shopTrackingWebPage = product.data('shop-tracking-web-page');
        var productAlcohol = product.data('product-alcohol');
        var listName = product.closest("[data-list-name]").attr('data-list-name');
        var aisleId = product.data('product-category-id');

        window['cartItem'] = new Product(sku, qty, optionId, optionCode, productName, shopTrackingToken, shopTrackingWebPage, productAlcohol, listName, aisleId);

        findFlowToAdd(product, errorBox, target);
    };

    window['executeAddProductToCart'] = function (product, errorBox, async) {
        var isMultiProducts = Array.isArray(product);
        var waitingContainer = isMultiProducts ? $(".addMultipleProductsContainer") : product;

        waitingContainer.addClass('in-progress relative');

        if (typeof async == 'undefined') {
            async = true;
        }

        //call ajax to controller on a valid add to cart
        $.ajax({
            url: shoppingCartUrl + '/entries',
            type: 'POST',
            async: async,
            headers: {
                'Accept-Language': window['acceptLanguage']
            },
            data: stringifyProduct(window['cartItem']),
            contentType: 'application/json; charset=utf-8',
            success: function (data) {

                if (!isMultiProducts) {
                    updateQuantityButtonsState(product);
                }

                var messages = data.messages;
                var statusCode = 'success';

                var productAdded = false;
                var productNotAddedError = false;
                var itemSku = '';

                if (data.entries) {
                    for (var i = 0; i < data.entries.length; i++) {
                        var item = data.entries[i];
                        if (item.status === 'success') {
                            updateProductTilesAfterUpdate(item);
                            productAdded = true;
                            itemSku = item.sku;
                        } else {
                            if (item.status === 'noStock' || item.status === 'unavailable') {
                                statusCode = 'unavailable';
                            }
                            productNotAddedError = true;
                        }
                    }
                }

                if (statusCode === 'unavailable') {
                    executeIfCallBack(addToCartErrorCallback);
                    displayFancyErrorMessage(messages, productNotAddedError && isReloadAfterClosingModalOrAddingToCart());
                } else if (!isMultiProducts) {
                    updateErrorMessages(product, messages, statusCode);
                }

                var quantityAdded = data.quantityAdded;
                if (quantityAdded > 0 && !isMultiProducts) {
                    var listName = product.closest("[data-list-name]").attr('data-list-name');

                    if (isInWebview()) {
                        sendCartItemUpdateEventToDevice(product);
                        sendNewQtyInCartEventToDevice(data.numberOfItems);
                    }
                    push_add_cart_info_metrics(product, quantityAdded, listName !== null ? listName : "");
                }

                waitingContainer.removeClass('in-progress relative');

                var $cartItemCount = $('.cart-qty span');
                var initialProductCount = parseInt($cartItemCount.text());
                var finalProductCount = parseInt(data.numberOfItems);
                var diffProductCount = finalProductCount - initialProductCount;

                if (addToCartDisplaySuccessNotification) {
                    window['displayCartNotification'](diffProductCount, waitingContainer, notificationSuccessCallback);
                }

                if (isReloadAfterClosingModalOrAddingToCart() && !product.is('.product-tile-spontaneous-purchase')) {
                    if (productAdded && async && !productNotAddedError) {
                        window['cartItem'] = null;
                        var pageCartLocation =  window.location.href.split('#')[0];
                        window.location.href = pageCartLocation + '#' + itemSku;
                        window.location.reload();
                    }
                } else {
                    setStoreId();
                    $cartItemCount.text(finalProductCount);

                    if (quantityAdded > 0) {
                        executeIfCallBack(addToCartEndCallback);
                    }

                    if (!isMultiProducts && product.hasClass('product-tile-spontaneous-purchase')) {
                        var max = +(product.data('max-qty'));
                        var qty = +(product.find('.qty-addToCart').first().text());
                        product.find('.plus-addToCart').prop('disabled', qty > max);
                        product.find('.minus-addToCart').prop('disabled', false);

                        _updateSpontaneousContinueButton();
                    }
                }
                isCartAvailable = true;
                window['cartItem'] = null;

                _updateExpressDelivery(data.totalEntries);

                if (typeof pixelSnapchatEnabled !== 'undefined' && pixelSnapchatEnabled && typeof snapchatKey !== 'undefined' && typeof userEmail !== 'undefined') {
                    pushAddToCartToSnapchat(snapchatKey, userEmail);
                }
                if (typeof pixelTikTokEnabled !== 'undefined' && pixelTikTokEnabled) {
                    var mainPrice = product.find('.pi--main-price').attr('data-main-price');
                    pushAddToCartToTikTok(mainPrice);
                }

                // Criteo tracking
                if (product.data('criteo-on-basket-change-beacon')) {
                    CriteoProductTracker.sendOnBasketChangeEvent(product.data('criteo-on-basket-change-beacon'));
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    waitingContainer.removeClass('in-progress relative');

                    if ((!!jqXHR.getResponseHeader('uPassAlreadyPurchased') || !!jqXHR.getResponseHeader('uPassUnavailableInstacart')) && jqXHR.responseJSON) {
                        let response = jqXHR.responseJSON;
                        displayFancyErrorMessage([response.message], true, isModalFastCheckoutOpened);
                    } else {
                        errorBox.text(window['detailsAddProductErrorMessage']);
                        errorBox.show();
                        $('html, body').animate({
                            scrollTop: errorBox.offset().top - 30
                        }, 800);

                        executeIfCallBack(addToCartErrorCallback);
                    }
                }
            }
        });
    };

    window['updateCartProduct'] = function (target) {
        var $tile = $(target).closest('.item-addToCart'),
            quantity = +$tile.find('.qty-addToCart').first().text(),
            minQty = +$tile.data("min-qty");

        hideErrorMessages($tile);

        //If the update comes from a Plus button, we treat it as an addProductToCart
        var plusTriggered = $(target).is('.plus-addToCart');

        if (quantity < minQty && !plusTriggered) {
            window['deleteCartItem'](target);
        } else if ((quantity == 0 || quantity == minQty) && plusTriggered) {
            window['addProductToCart'](target);
        } else {
            window['updateCartProductQty'](target);
        }
    };

    window['updateCartProductQty'] = function (target) {
        var $tile = $(target).closest('.item-addToCart'),
            $cutSelect = $tile.find('select[name="select_element"]'),
            optionCode = $cutSelect ? $cutSelect.attr('data-configuration-code') : null,
            optionId = $cutSelect ? $cutSelect.val() : null,
            entryNumber = +$tile.attr('data-cart-entry'),
            productCode = $tile.data('product-code'),
            itemData = {
                quantity: +$tile.find('.qty-addToCart').first().text(),
                productCode: productCode,
                optionCode: optionCode,
                optionId: optionId,
                substitutionPermission: $tile.data('substitution-permission')
            };

        $tile.addClass('in-progress');

        $.ajax({
            url: shoppingCartUrl + '/entries/' + entryNumber,
            type: "PATCH",
            headers: {
                "Accept-Language": lang
            },
            data: JSON.stringify(itemData),
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                var $data = $(data);

                var nbItemsInCart = parseInt($data.filter(".item-addToCart").attr('data-cart-items-number'));
                _updateHeaderCartItemNumber(nbItemsInCart);

                var productCode = $data.filter(".item-addToCart").attr('data-product-code');
                var entryNumber = parseInt($data.filter(".item-addToCart").attr('data-cart-entry'));
                var $updatedProductTiles = $('[data-product-code="' + productCode + '"]');
                $updatedProductTiles.attr('data-cart-entry', entryNumber);

                if ($tile.hasClass('product-tile-spontaneous-purchase')) {
                    //Quickly refresh the tiles to avoid incorrect display of the quantity in other screens
                    var $spontaneousTilesToUpdate = $('[data-product-code="' + productCode + '"]').not('.product-tile-cart-starter');
                    if ($spontaneousTilesToUpdate.length) {
                        $spontaneousTilesToUpdate.find('.qty-addToCart').text(itemData.quantity);
                    }
                }

                if (isInWebview()) {
                    sendCartItemUpdateEventToDevice($tile);
                    sendNewQtyInCartEventToDevice(nbItemsInCart);
                }
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    var url = cleanUpUrlFromPreviousErrors(window.location.href);
                    window.location = TINK.validateUrl(url + "&error-action=update&product-code=" + productCode);
                }
            },
            complete: function () {
                $tile.removeClass('in-progress');
            }
        });
    };

    window['deleteCartItem'] = function (target) {
        var $tile = $(target).closest('.item-addToCart'),
            entryNumber = +$tile.attr('data-cart-entry'),
            productCode = $tile.data('product-code'),
            itemData = {
                productCode: productCode
            };

        $tile.addClass('in-progress');

        $.ajax({
            url: shoppingCartUrl + '/entries/' + entryNumber,
            type: "DELETE",
            headers: {
                "Accept-Language": lang
            },
            data: JSON.stringify(itemData),
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                _updateHeaderCartItemNumber(data.cartNbItems);
                _updateExpressDelivery(data.cartTotalEntries);

                var $productTiles = $('[data-product-code="' + productCode + '"]');
                let productTileType = $productTiles.data('tile-type');

                if (productTileType != 'spontaneous-tile') {
                    $productTiles.find('.pt--actions, .pi--actions').addClass('actions--not-in-cart');
                }

                $productTiles.find('.pt__content--actions').removeClass('in-cart');
                $productTiles.find('.minus-updateCart, .plus-updateCart').attr('tabindex', -1);
                $tile.find('.action__add-to-cart').focus();

                _resetQuantity($productTiles);
                _resetEntryNumber($productTiles);

                if ($tile.hasClass('product-tile-spontaneous-purchase')) {
                    _updateSpontaneousContinueButton();
                }

                if (!data.existingProduct) {
                    $productTiles.find('.pt--image--incart, .pt--image--incart-wrapper').addClass('hide');

                    if ($productTiles.hasClass('productPDP')) {
                        $('.pdpVisuals .pt--image--incart-wrapper').addClass('hide');
                    }
                }

                if (isInWebview()) {
                    sendCartItemUpdateEventToDevice($tile);
                    sendNewQtyInCartEventToDevice(data.cartNbItems);
                }

                push_remove_cart_info_metrics($tile);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    var url = cleanUpUrlFromPreviousErrors(window.location.href);
                    window.location = TINK.validateUrl(url + "&error-action=delete&product-code=" + productCode);
                }
            },
            complete: function () {
                $tile.removeClass('in-progress');
            }
        });
    };

    window['removePromoCodeFromCart'] = function (target) {
        $.ajax({
            url: shoppingCartUrl + '/promos/' + $(target).closest('.coupon-addToCart').data('coupon-id'),
            type: 'DELETE',
            headers: {
                'Accept-Language': window['acceptLanguage']
            },
            contentType: 'application/json; charset=utf-8',
            success: function () {
                location.reload();
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    location.reload();
                }
            }
        });
    };

    window['unclipCouponFromCart'] = function (target) {
        $(".alert--error").hide();
        $.ajax({
            url: "/my-coupon/clip-to-card/" + $(target).data("coupon-xcid"),
            type: "DELETE",
            headers: {
                "Accept-Language": window['acceptLanguage']
            },
            success: function () {
                window.location.reload(true);
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    var $alert = $('.alert--error');
                    $alert.text(unclipErrorMsg);
                    $alert.show();
                    $('html, body').animate({scrollTop: 0}, 'fast');
                }
            }
        });
    };

    window['displayCartNotification'] = function (nbProductAdded, waitingContainer, callbackNotifSuccess) {
        notificationSuccessCallback = callbackNotifSuccess;
        if (nbProductAdded > 0) {
            var $addToCartNotification = $('.notification--generic');
            if ($addToCartNotification.length) {
                $addToCartNotification.find('.nbProductAdded').text(nbProductAdded);
                if (nbProductAdded > 1) {
                    $addToCartNotification.find('.possiblyPlural').addClass('plural');
                } else {
                    $addToCartNotification.find('.possiblyPlural').removeClass('plural');
                }
                executeIfCallBack(notificationSuccessCallback);
                addToCartDisplaySuccessNotification = false; // reset the flag for next add to cart
                $addToCartNotification.dishide('open');
                $addToCartNotification.notification();
            }
        }
        TINK.stopProgress(waitingContainer);
    };

    window['executeSendProductToCart'] = (products) => {
        if (typeof async == 'undefined') {
            async = true;
        }
        return new Promise((resolve, reject) =>
            $.ajax({
                url: `${shoppingCartUrl}/entries`,
                type: 'POST',
                async: async,
                headers: {
                    'Accept-Language': window['acceptLanguage']
                },
                data: stringifyProduct(products),
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    resolve(data);
                },
                error: function (jqXHR) {
                    if (!TINK.redirectIfConflict(jqXHR)) {
                        reject(jqXHR);
                    }
                }
            })
        );
    }
});
